if (!customElements.get('lc-scrolling-announcement')) {
  class LcScrollingAnnouncement extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.container = this.querySelector('.lc-scrolling-announcement__container');
      this.init();
    }
    init() {
      if (this.childElementCount === 1) {
        this.container.classList.add('lc-scrolling-announcement__container--animated');
        for (let index = 0; index < 10; index++) {
          this.clone = this.container.cloneNode(true);
          this.appendChild(this.clone);
        }
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.remove('lc-scrolling-announcement--paused');
              } else {
                this.classList.add('lc-scrolling-announcement--paused');
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );
        observer.observe(this);
      }
    }
  }
  customElements.define('lc-scrolling-announcement', LcScrollingAnnouncement);
}
